import React from 'react';
import { QrTitle } from '../../../components/buttons/IconButtons';
import { SCANNER_REGION_ID, SCANNER_STATUS } from '../Model/Model';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Camera preview of the material request scanner.
 *
 * @param {Function} t Translation function.
 * @param {string} status Current scanner status.
 * @returns {JSX.Element}
 */
const ScannerCard = ({
    t,
    status,
}) => {
    const isCameraOn = status === SCANNER_STATUS.SCANNING || status === SCANNER_STATUS.RESOLVING;

    return (
        <div className='scanner-main-card border-radius-16px background-general-00'>
            <div className='scanner-title-row'>
                <QrTitle className='btn-icon-svg-32px' />

                <p className='scanner-title font-color-primary-950 ibl-font-w-700 mb-0'>
                    {t('qr_scanner')}
                </p>
            </div>

            <p className='scanner-subtitle fs-16px ibl-font-w-400 font-color-shades-500 mb-3'>
                {t('point_the_camera_at_the_material_request_qr_code')}
            </p>

            <div className={`scanner-region border-radius-16px ${isCameraOn ? 'scanner-region-live' : ''}`}>
                <div id={SCANNER_REGION_ID} className='scanner-region-video' />

                <div className={`scanner-frame ${status === SCANNER_STATUS.SCANNING ? 'scanner-frame-active' : ''}`}>
                    <span className='scanner-corner scanner-corner-tl' />
                    <span className='scanner-corner scanner-corner-tr' />
                    <span className='scanner-corner scanner-corner-bl' />
                    <span className='scanner-corner scanner-corner-br' />

                    {status === SCANNER_STATUS.SCANNING && <span className='scanner-laser' />}
                </div>

                {!isCameraOn && (
                    <div className='scanner-region-placeholder'>
                        <span className='scanner-placeholder-icon'>
                            <QrTitle className='btn-icon-svg-32px' />
                        </span>

                        <p className='fs-16px ibl-font-w-400 font-color-shades-500 mb-0 mt-2'>
                            {t('camera')}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ScannerCard;
